// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Icons-module--fadeInAnimation--c1969";
export var iconImg = "Icons-module--iconImg--73af5";
export var iconWrapper = "Icons-module--iconWrapper--62144";
export var iconsWrapper = "Icons-module--iconsWrapper--7b240";
export var item = "Icons-module--item--bf1cc";
export var link = "Icons-module--link--3690f";
export var wide = "Icons-module--wide--a2c4c";